import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-quill-new/dist/quill.snow.css";
// or
import "quill/dist/quill.snow.css";

function BlogDetails() {
    const { slug } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem("token");

    useEffect(() => {
        const fetchBlog = async () => {
            setLoading(true);
            try {
                // Better API URL handling
                const apiUrl = process.env.REACT_APP_API_URL || '/api';
                const endpoint = `${apiUrl}/blogs/slug/${slug}`;

                console.log('Fetching from:', endpoint); // Debug log

                const { data } = await axios.get(endpoint, {
                    headers: {
                        'Authorization': token ? `Bearer ${token}` : undefined,
                        'Content-Type': 'application/json'
                    }
                });

                setBlog(data);
            } catch (err) {
                console.error('Blog fetch error:', err);
                toast.error(err.response?.data?.message || "Failed to load blog details");
            } finally {
                setLoading(false);
            }
        };

        if (slug) {
            fetchBlog();
        }
    }, [slug, token]);

    if (loading) return (
        <div className="text-center mt-5">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading blog post...</p>
        </div>
    );
    console.log(blog.full_description);
    if (!blog) return (
        <div className="text-center mt-5">
            <p className="text-danger">Blog post not found</p>
            <Link to="/blogs" className="btn btn-primary">Back to Blogs</Link>
        </div>
    );

    return (
        <div>
            <ToastContainer position="bottom-right" />

            {/* Hero Section */}
            <div className="container-fluid py-5 mb-5 navyblue-bg hero-header">
                <div className="container py-5 text-center">
                    <h1 className="display-3 fw-bold text-white">
                        {blog.title}
                    </h1>
                    <p className="footer-color fs-5 mt-3">
                        {blog.intro}
                    </p>
                    <small className="text-white-50">
                        By {blog.author || "Admin"} | {new Date(blog.date).toLocaleDateString()}
                    </small>
                </div>
            </div>

            {/* Image and Content */}
            <div className="container col-md-8 mb-4">
                {blog.image && (

                    <div className="text-center mb-4">
                        <img
                            src={blog.image}
                            alt={blog.title}
                            className="img-fluid"
                            style={{ maxHeight: "400px", objectFit: "cover", borderRadius: "12px" }}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = '/placeholder-image.jpg';
                            }}
                        />
                    </div>
                )}

                {/* Full Description */}
                <div className="p-4 shadow-sm bg-light rounded">
                    <div className="blog-content ">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: blog.full_description.replace(/&nbsp;/g, " "),
                            }}
                        />
                    </div>
                </div>
            </div>
            <style>
                {`
                   .blog-content a{
                   color: #ff8c00!important;
                   }
                `}



            </style>

            {/* Back Button */}
            <div className="mt-4 text-center mb-5">
                <Link
                    to="/blogs"
                    className="btn px-4 py-2"
                    style={{ backgroundColor: "#ff8c00", color: "#fff", borderRadius: "25px" }}
                >
                    ← Back to Blogs
                </Link>
            </div>
        </div>
    );
}

export default BlogDetails;